// PROD-3310 billing bridge.
// Mirrors: dev-scrips-pm-react src/components/ui/popover.tsx (base-ui Popover: `Popover`, `PopoverTrigger`,
// `PopoverContent` with `align` / `side` / `sideOffset` (default 4), `PopoverHeader`, `PopoverTitle`,
// `PopoverDescription`).
// Wraps:   Signal DS `AnchoredPopover`, `AnchoredPopoverTrigger`, `AnchoredPopoverContent`, `AnchoredPopoverHeader`,
// `AnchoredPopoverTitle`, `AnchoredPopoverDescription` — the same base-ui Popover parts, portalled and positioned by
// the DS, so `open` / `onOpenChange` / `render` / `align` pass straight through.
// Overrides: PM's names only, and PM's `sideOffset` default of 4. The panel look (radius, hairline, shadow, padding) is
// the DS panel's; PM's `w-72` / `p-2` call-site classes still apply through className.
import type { ComponentProps } from 'react';
import {
  AnchoredPopover,
  AnchoredPopoverContent,
  AnchoredPopoverDescription,
  AnchoredPopoverHeader,
  AnchoredPopoverTitle,
  AnchoredPopoverTrigger,
} from '@scripsteam/scrips-signal-ds';

export function Popover(props: ComponentProps<typeof AnchoredPopover>) {
  return <AnchoredPopover {...props} />;
}

export function PopoverTrigger(props: ComponentProps<typeof AnchoredPopoverTrigger>) {
  return <AnchoredPopoverTrigger data-slot="popover-trigger" {...props} />;
}

export function PopoverContent({ sideOffset = 4, ...props }: ComponentProps<typeof AnchoredPopoverContent>) {
  return <AnchoredPopoverContent data-slot="popover-content" sideOffset={sideOffset} {...props} />;
}

export function PopoverHeader(props: ComponentProps<typeof AnchoredPopoverHeader>) {
  return <AnchoredPopoverHeader data-slot="popover-header" {...props} />;
}

export function PopoverTitle(props: ComponentProps<typeof AnchoredPopoverTitle>) {
  return <AnchoredPopoverTitle data-slot="popover-title" {...props} />;
}

export function PopoverDescription(props: ComponentProps<typeof AnchoredPopoverDescription>) {
  return <AnchoredPopoverDescription data-slot="popover-description" {...props} />;
}
